import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetExamList = () => {
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", `/tryout/list`)
    }, [])

    return [fetchResult]
}

export default useGetExamList